import {EntityHistory} from "./EntityHistory";
import {DriverType} from "./enums/DriverType";
import {findEntityById, toFullEntityResult} from "./helpers/toFullEntityResult";
import IHolder from "./interfaces/IHolder";
import {DriverId} from "./nominalTypes/DriverId";
import {DriverResult} from "./types/DriverResult";
import {FullEntityRelation} from "./types/EntityRelation";
import {PermitEntityResult, PermitFullEntityResult} from "./types/PermitEntityResult";

function createEmptyDriver(driverId: DriverId): DriverResult {
	return {
		id: driverId,
		type: DriverType.None,
		fullName: driverId,
		licenseNumber: "",
		attachments: [],
		customData: []
	}
}

class Drivers {
	static get(holder: IHolder, id: DriverId): DriverResult {
		return findEntityById(holder.drivers, id, createEmptyDriver);
	}

	static getAll(holder: IHolder, ids: DriverId[]): DriverResult[] {
		const result: DriverResult[] = [];
		for (const id of ids) {
			result.push(this.get(holder, id));
		}
		return result;
	}

	static getChanged(holder: IHolder, driver: PermitEntityResult<DriverId>[]): FullEntityRelation<DriverId, DriverResult> | undefined {
		const c = EntityHistory.changed(driver);
		if (!c) {
			return;
		}

		const {original, changed} = c;
		return {
			original: toFullEntityResult(holder.drivers, original, createEmptyDriver),
			changed: changed && toFullEntityResult(holder.drivers, changed, createEmptyDriver)
		};
	}

	static getValid(holder: IHolder, driver: PermitEntityResult<DriverId>[]): PermitFullEntityResult<DriverId, DriverResult> | undefined {
		const e = EntityHistory.approvedOrDefault(driver);
		if (e == null) {
			return;
		}
		return toFullEntityResult(holder.drivers, e, createEmptyDriver);
	}
}

export {Drivers};
